import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { CARTVIEW, GETADDRESS } from 'src/app/config';

@Component({
    selector: 'app-product-holder',
    templateUrl: './product-holder.component.html',
    styleUrls: ['./product-holder.component.css'],
    
})
export class ProductHolderComponent implements OnInit {
  @Input() mostselling;
  @Input() url3;
  @Input() heading;
  @Input() redirect;
  @Input() pricelist;
  priceWeight:any;
  value:boolean;
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 4,
    "dots": false,
    "infinite": true,
    "autoplay": true,
    "arrows": true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  };

 wish:any;
 cart:any[];
drop:any;
  addresses: any;
  state: any;
//@ViewChild('addclosebutton') addclosebutton;
//@ViewChild('deleteclosebutton') deleteclosebutton;
  constructor(private api:ApiService,private router:Router) {
    this.drop=this.api.drop;

  }






 go(value) {
   this.api.godetail(value);
 }
 wishlist(pid) {
    console.log("in wishlist");
   //console.log(pid);

    if(this.drop==0)
    {
       // document.getElementById("openModalButton").click();
       console.log(pid);
      this.api.setGoto();
      this.api.onSuccess('Please Login First to Continue',"Login");
    }
    else if(this.drop==1)
   {console.log('lgin'+pid);
     this.api.checkWishlist(pid);
   }
 }
 // goLogin()
 // {
 //   this.router.navigate(['/login']);
 // }
 checkHeart(pid)
 {

   //console.log("checkheart");
   this.wish = this.api.getWishlist();
   if (this.wish) {
           let result = this.wish.find(x => x.product_id === pid);
       //  console.log("result="+result);
           if (result)
           {
            // console.log("present");
             return true;

           }
           else
           {
             //console.log("not present");
             return false;

           }
     }
     else{
       //console.log("not present");
       return false;
     }
 }

 deleteWishlist(pid)
 {
     this.api.deleteWishlist(pid);

 }


  ngOnInit() {
    console.log("mostselling", this.mostselling)
    console.log("pricelist", this.pricelist)
    console.log("igst", this.api.igst)
    if(this.mostselling && this.pricelist)
    {
      this.priceWeight = this.api.calculateFilter(this.mostselling,this.pricelist,this.api.igst);
    }
  }

}
